import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ComingSoonBadge } from '../../BigNumbers/components/Card/styles';
import { BadgeContainer } from '../../RowCardsOverview/components/styles';
import {
  BetaContent, HistoryHeader, HistoryTooltip, TitleGraph,
} from '../../styles';
import { InfoTooltip } from '../InfoTooltip';
import { GraphContainer, HistoryContainer } from './styles';

interface HistoryCardProps {
  id: string;
  dataTestId: string;
  disabledTooltip: boolean;
  title: string;
  description: string;
  children: ReactNode;
  comingSoon?: boolean;
  beta?: boolean;
}

export function HistoryCard({
  dataTestId,
  disabledTooltip,
  title,
  children,
  description,
  id,
  comingSoon,
  beta,
}:Readonly<HistoryCardProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <HistoryContainer
      data-testId={dataTestId}
      style={{
        position: 'relative',
      }}
    >
      <HistoryHeader>
        <TitleGraph comingSoon={comingSoon}>{title}</TitleGraph>
        <InfoTooltip
          id={id}
          disabled={disabledTooltip}
        >
          <HistoryTooltip>
            <span>{description}</span>
          </HistoryTooltip>
        </InfoTooltip>
        {beta && <BetaContent style={{ right: 20 }}>Beta</BetaContent>}
      </HistoryHeader>
      <GraphContainer comingSoon={comingSoon}>
        {children}
      </GraphContainer>
      {comingSoon && (
        <BadgeContainer>
          <ComingSoonBadge>{t('emBreve')}</ComingSoonBadge>
        </BadgeContainer>
      )}
    </HistoryContainer>
  );
}
